"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HR;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _theme = require("HubStyleTokens/theme");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Styles = require("../utils/Styles");

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  background-color: ", ";\n  border: 0;\n  height: 1px;\n\n  /* Set min-height and width so that it will never be shrunk inside a flex container */\n  min-height: 1px;\n  width: 100%;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledHR = _styledComponents.default.hr.withConfig({
  displayName: "HR__StyledHR",
  componentId: "sc-1tslhd9-0"
})(_templateObject(), _theme.HR_BORDER_COLOR, function (_ref) {
  var distance = _ref.distance;
  return (0, _Styles.setDistance)(distance);
});

function HR(props) {
  return _react.default.createElement(StyledHR, props);
}

HR.propTypes = {
  distance: _propTypes.default.oneOf(_Styles.DISTANCE_KEYS).isRequired
};
HR.defaultProps = {
  distance: 'medium'
};
HR.displayName = 'HR';
module.exports = exports.default;